(function ($) {
  var apptBook = Drupal.appointmentBooking;

  function getURLParam(oTarget, sVar) {
    return decodeURI(oTarget.search.replace(new RegExp('^(?:.*[&\\?]' + encodeURI(sVar).replace(/[\.\+\*]/g, '\\$&') + '(?:\\=([^&]*))?)?.*$', 'i'), '$1'));
  }

  function cancelAppointment(token, id, callback, errorCallback) {
    var url = 'https://' + window.location.hostname + '/_abapi/api/v1/appointments/' + id,
      params = {
        token: token,
        _method: 'DELETE'
      };

    $.ajax(
      {
        url: url,
        type: 'POST',
        data: params,
        success: function (r) {
          if (typeof callback === 'function') {
            callback(r);
          }
        },

        error: function (err) {
          var r = JSON.parse(err.responseText);

          if (typeof errorCallback === 'function') {
            errorCallback(r);
          }
        }
      }
    );
  }
  Drupal.behaviors.apptBookConfirm = {
    attach: function (context) {
      var loc = window.parent.location !== window.location ? window.parent.location : window.location,
        apptToken = getURLParam(loc, 'token'),
        apptId = getURLParam(loc, 'appointment_id'),
        $container = $('#appointment-cancellation'),
        $cMessage = $container.find('.cancel-content'),
        $eMessage = $container.find('.error-content');

      function onCancelSuccess(r) {
        $cMessage.show();
        $eMessage.hide();
      }

      function onCancelError(r) {
        $eMessage.show();
        $cMessage.hide();
      }

      if (apptToken && apptId) {
        cancelAppointment(apptToken, apptId, onCancelSuccess, onCancelError);
      }
    }
  };
})(jQuery);
